import React from 'react';
import { canManageToolingEquipment } from '../../utils/roleConstants';
import { parseStoredUser } from '../../utils/moduleAccess';
import { apiFetch } from '../../_services/apiFetch';
import { Form, FormGroup, FormControl, Button, Card, Modal, Row, Col } from 'react-bootstrap';
import { redirectUnlessToolingEquipment } from '../../utils/moduleAccess';
import config from '../../../config';
import DataTable from 'react-data-table-component';
import moment from 'moment';
import utils from '../../utils';
import MasterPartNoInput from '../../_components/MasterPartNoInput';
import DataTableEllipsisText from '../../_components/DataTableEllipsisText';
import { isPartNoCreateEnabled, MASTER_PART_NO_VALIDATION_STATUS } from '../../utils/masterPartNoValidation';
import DatacoLoadingIndicator from '../../_components/DatacoLoadingIndicator';
import ToolingMasterDataPagination from './ToolingMasterDataPagination';
import { TOOLING_TABLE_STYLES } from './toolingTableStyles';


const TOOLING_CONDITION_LABELS = {
    0: 'OK',
    1: 'NG',
    2: 'Under repair',
    3: 'End of Life'
};

class ToolingMasterData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            toolingNo: '',
            partNo: '',
            toolingSystem: '',
            toolingLifeAlert: 0,
            toolingLife: 0,
            noCavity: 0,
            machineTonnage: 0,
            baseMaterial: '',
            insertSteel: '',
            coreSteel: '',
            ejectionSystem: '',
            rawMaterialGrade: '',
            partWeightNet: 0,
            shotWeightGross: 0,
            requiredMachineTonnage: 0,
            surfaceRequirement: '',
            toolingCondition: 0,
            company: 0,
            products: [],
            body: [],
            keyword: '',
            statusFilter: 'all',
            modalShow: false,
            newMode: false,
            currentPage: 1,
            rowsPerPage: 10,
            totalRows: 0,
            offset: 0,
            partNoValidationStatus: MASTER_PART_NO_VALIDATION_STATUS.IDLE,
            loading: false
        };
        this.tableRequestSeq = 0;

        this.columns = [
            {
                name: 'No',
                selector: row => row.no,
                width: '70px',
            },
            {
                name: 'Part No',
                selector: row => row.partNo,
                cell: row => <DataTableEllipsisText value={row.partNo} />,
                sortable: true,
            },
            {
                name: 'Tooling No',
                selector: row => row.toolingNo,
                cell: row => <DataTableEllipsisText value={row.toolingNo} />,
                sortable: true,
            },
            {
                name: 'Tooling System',
                selector: row => row.toolingSystem,
                cell: row => <DataTableEllipsisText value={row.toolingSystem} />,
                sortable: true,
            },
            {
                name: 'Tooling Status',
                selector: row => row.toolingConditionLabel,
                cell: row => <DataTableEllipsisText value={row.toolingConditionLabel} />,
                sortable: true,
            },
            {
                name: 'Actions',
                cell: (row, rowIndex) => this.cellButton(row, rowIndex),
                ignoreRowClick: true,
                allowOverflow: true,
                width: '170px',
            }
        ];
    }

    componentDidMount() {
        if (localStorage.getItem('user') != null) {
            this.buildHtmlTable();
        }
    }

    safeString(value) {
        if (value === null || value === undefined) return '';
        const text = String(value);
        return text === 'null' || text === 'undefined' ? '' : text;
    }

    safeNumber(value) {
        if (value === null || value === undefined || value === '') return 0;
        const numberValue = Number(value);
        return isNaN(numberValue) ? 0 : numberValue;
    }

    getToolingConditionLabel(value) {
        const numericValue = this.safeNumber(value);
        return TOOLING_CONDITION_LABELS[numericValue] || TOOLING_CONDITION_LABELS[0];
    }

    normalizeTooling(data, index, offset) {
        const toolingCondition = this.safeNumber(data.toolingCondition);
        return {
            no: index + offset + 1,
            id: data.id,
            toolingNo: this.safeString(data.toolingNo),
            partNo: this.safeString(data.partNo),
            toolingSystem: this.safeString(data.toolingSystem),
            toolingLifeAlert: this.safeNumber(data.toolingLifeAlert),
            toolingLife: this.safeNumber(data.toolingLife),
            noCavity: this.safeNumber(data.noCavity),
            machineTonnage: this.safeNumber(data.machineTonnage),
            baseMaterial: this.safeString(data.baseMaterial),
            insertSteel: this.safeString(data.insertSteel),
            coreSteel: this.safeString(data.coreSteel),
            ejectionSystem: this.safeString(data.ejectionSystem),
            rawMaterialGrade: this.safeString(data.rawMaterialGrade),
            partWeightNet: this.safeNumber(data.partWeightNet),
            shotWeightGross: this.safeNumber(data.shotWeightGross),
            requiredMachineTonnage: this.safeNumber(data.requiredMachineTonnage),
            surfaceRequirement: this.safeString(data.surfaceRequirement),
            toolingCondition,
            toolingConditionLabel: this.getToolingConditionLabel(toolingCondition),
            company: this.safeNumber(data.company)
        };
    }

    buildHtmlTable(page = null, limit = null) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        };

        const user = JSON.parse(localStorage.getItem('user'));
        const currentPage = page !== null ? page : this.state.currentPage;
        const rowsPerPage = limit !== null ? limit : this.state.rowsPerPage;
        const offset = (currentPage - 1) * rowsPerPage;
        const requestSeq = ++this.tableRequestSeq;
        this.setState({ loading: true });

        if (user != null) {
            const params = new URLSearchParams({
                company: String(user.accountId),
                keyword: this.state.keyword || '',
                toolingCondition: this.state.statusFilter,
                limit: String(rowsPerPage),
                offset: String(offset),
            });

            return apiFetch(`${config.apiUrl}/getToolingByCompany?${params.toString()}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        return text && JSON.parse(text);
                    });
                })
                .then(body => {
                    if (requestSeq !== this.tableRequestSeq) return;

                    const data = body && body.data && Array.isArray(body.data) ? body.data : (Array.isArray(body) ? body : []);
                    const totalRows = body && body.meta && body.meta.total_count
                        ? body.meta.total_count
                        : (body && body.pagination && body.pagination.total ? body.pagination.total : data.length);

                    this.setState({
                        products: data.map((item, index) => this.normalizeTooling(item, index, offset)),
                        body: data,
                        totalRows,
                        currentPage,
                        rowsPerPage,
                        offset,
                        loading: false
                    });
                })
                .catch(error => {
                    if (requestSeq === this.tableRequestSeq) {
                        console.error('Error fetching tooling master data:', error);
                        this.setState({ products: [], body: [], totalRows: 0, loading: false });
                    }
                });
        }

        this.setState({ loading: false });
        return Promise.resolve();
    }

    exportExcel() {
        utils.tableToExcel('tooling-master-data-export-table', 'tooling', 'Tooling_' + moment().format('YYYYMMDD') + '.xls');
    }

    openNewModal() {
        this.setState({
            id: 0,
            toolingNo: '',
            partNo: '',
            toolingSystem: '',
            toolingLifeAlert: 0,
            toolingLife: 0,
            noCavity: 0,
            machineTonnage: 0,
            baseMaterial: '',
            insertSteel: '',
            coreSteel: '',
            ejectionSystem: '',
            rawMaterialGrade: '',
            partWeightNet: 0,
            shotWeightGross: 0,
            requiredMachineTonnage: 0,
            surfaceRequirement: '',
            toolingCondition: 0,
            partNoValidationStatus: MASTER_PART_NO_VALIDATION_STATUS.IDLE,
            newMode: true,
            modalShow: true
        });
    }

    onClickProductSelected(row) {
        this.setState({
            newMode: false,
            id: this.safeNumber(row.id),
            toolingNo: this.safeString(row.toolingNo),
            partNo: this.safeString(row.partNo),
            toolingSystem: this.safeString(row.toolingSystem),
            toolingLifeAlert: this.safeNumber(row.toolingLifeAlert),
            toolingLife: this.safeNumber(row.toolingLife),
            noCavity: this.safeNumber(row.noCavity),
            machineTonnage: this.safeNumber(row.machineTonnage),
            baseMaterial: this.safeString(row.baseMaterial),
            insertSteel: this.safeString(row.insertSteel),
            coreSteel: this.safeString(row.coreSteel),
            ejectionSystem: this.safeString(row.ejectionSystem),
            rawMaterialGrade: this.safeString(row.rawMaterialGrade),
            partWeightNet: this.safeNumber(row.partWeightNet),
            shotWeightGross: this.safeNumber(row.shotWeightGross),
            requiredMachineTonnage: this.safeNumber(row.requiredMachineTonnage),
            surfaceRequirement: this.safeString(row.surfaceRequirement),
            toolingCondition: this.safeNumber(row.toolingCondition),
            company: this.safeNumber(row.company),
            modalShow: true
        });
    }

    onDeleteProduct(row) {
        apiFetch(`${config.apiUrl}/deleteTooling`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: row.id,
            })
        })
            .then((response) => {
                if (response.status == 200) {
                    window.alert('Deleted Successfully.');
                    this.buildHtmlTable();
                }
            });
    }

    cellButton(row, rowIndex) {
        if (!canManageToolingEquipment(parseStoredUser(localStorage.getItem('user')))) {
            return <Button size="sm" variant="outline-secondary" onClick={() => this.onClickProductSelected(row, rowIndex)}>View details</Button>;
        }

        return (
            <div className="d-flex gap-2">
                <Button
                    variant="outline-primary"
                    size="sm"
                    type="button"
                    onClick={() => this.onClickProductSelected(row, rowIndex)}
                >
                    Edit
                </Button>
                <Button
                    variant="outline-danger"
                    size="sm"
                    type="button"
                    onClick={() =>
                        window.confirm('Are you sure you delete this data?') && this.onDeleteProduct(row)
                    }
                >
                    Delete
                </Button>
            </div>
        );
    }

    handlePageChange = (page) => {
        this.setState({ currentPage: page }, () => {
            this.buildHtmlTable(page, this.state.rowsPerPage);
        });
    };

    handleRowsPerPageChange = (newRowsPerPage, page) => {
        this.setState({ rowsPerPage: newRowsPerPage, currentPage: page }, () => {
            this.buildHtmlTable(page, newRowsPerPage);
        });
    };

    handlePartNoValidationChange = (partNoValidationStatus) => {
        this.setState({ partNoValidationStatus });
    };

    render() {
        const accessDenied = redirectUnlessToolingEquipment(localStorage.getItem('user'));
        const canManage = canManageToolingEquipment(parseStoredUser(localStorage.getItem('user')));
        if (accessDenied) return accessDenied;

        let { keyword, modalShow, newMode, products } = this.state;
        const toolingNo = this.safeString(this.state.toolingNo);
        const partNo = this.safeString(this.state.partNo);
        const toolingSystem = this.safeString(this.state.toolingSystem);
        const toolingLifeAlert = this.safeNumber(this.state.toolingLifeAlert);
        const toolingLife = this.safeNumber(this.state.toolingLife);
        const noCavity = this.safeNumber(this.state.noCavity);
        const machineTonnage = this.safeNumber(this.state.machineTonnage);
        const baseMaterial = this.safeString(this.state.baseMaterial);
        const insertSteel = this.safeString(this.state.insertSteel);
        const coreSteel = this.safeString(this.state.coreSteel);
        const ejectionSystem = this.safeString(this.state.ejectionSystem);
        const rawMaterialGrade = this.safeString(this.state.rawMaterialGrade);
        const partWeightNet = this.safeNumber(this.state.partWeightNet);
        const shotWeightGross = this.safeNumber(this.state.shotWeightGross);
        const requiredMachineTonnage = this.safeNumber(this.state.requiredMachineTonnage);
        const surfaceRequirement = this.safeString(this.state.surfaceRequirement);
        const toolingCondition = this.safeNumber(this.state.toolingCondition);

        let handleClose = () => {
            this.setState({
                modalShow: false,
                id: 0,
                toolingNo: '',
                partNo: '',
                toolingSystem: '',
                toolingLifeAlert: 0,
                toolingLife: 0,
                noCavity: 0,
                machineTonnage: 0,
                baseMaterial: '',
                insertSteel: '',
                coreSteel: '',
                ejectionSystem: '',
                rawMaterialGrade: '',
                partWeightNet: 0,
                shotWeightGross: 0,
                requiredMachineTonnage: 0,
                surfaceRequirement: '',
                toolingCondition: 0,
                partNoValidationStatus: MASTER_PART_NO_VALIDATION_STATUS.IDLE
            });
        };

        const payload = {
            toolingNo,
            partNo,
            toolingSystem,
            toolingLifeAlert,
            toolingLife,
            noCavity,
            machineTonnage,
            baseMaterial,
            insertSteel,
            coreSteel,
            ejectionSystem,
            rawMaterialGrade,
            partWeightNet,
            shotWeightGross,
            requiredMachineTonnage,
            surfaceRequirement,
            toolingCondition
        };

        let handleSave = () => {
            window.confirm('Are you sure you update this data?') && apiFetch(`${config.apiUrl}/updateTooling`, {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ...payload,
                    id: this.state.id,
                })
            })
                .then((response) => {
                    if (response.status == 200) {
                        window.alert('Update Successfully.');
                        this.setState({ modalShow: false });
                        this.buildHtmlTable();
                    }
                });
        };

        let handleCreate = () => {
            apiFetch(`${config.apiUrl}/uploadTooling`, {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ...payload,
                    company: JSON.parse(localStorage.getItem('user')).accountId,
                })
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.setState({ modalShow: false, newMode: false });
                        window.alert('New data created successfully.');
                        this.buildHtmlTable();
                    }
                });
        };

        return (
            <div className="container-fluid py-4">
                <h2>Tooling Master Data</h2>
                <p className="text-muted">Manage tooling master data.</p>
                <div className="d-flex flex-wrap justify-content-between gap-2 mb-3">
                    <span role="status">
                        {this.state.loading
                            ? 'Loading tooling…'
                            : `${this.state.totalRows} tooling records`}
                    </span>
                    <div className="d-flex flex-wrap gap-2">
                        <Button
                            variant="outline-secondary"
                            disabled={this.state.loading}
                            onClick={() => this.buildHtmlTable()}
                        >
                            Refresh
                        </Button>
                        <Button variant="outline-primary" onClick={() => this.exportExcel()}>
                            Export
                        </Button>
                        {canManage && <Button variant="primary" onClick={() => this.openNewModal()}>
                            Add tooling
                        </Button>}
                    </div>
                </div>
                <Card>
                    <Card.Body>
                        <Form
                            className="mb-3"
                            onSubmit={(event) => {
                                event.preventDefault();
                                this.setState({ currentPage: 1, offset: 0 }, () => {
                                    this.buildHtmlTable(1, this.state.rowsPerPage);
                                });
                            }}
                        >
                            <Row className="g-3">
                                <Col md={6}>
                                    <FormGroup controlId="tooling-search">
                                        <Form.Label>Search tooling</Form.Label>
                                        <div className="d-flex gap-2">
                                            <FormControl
                                                type="text"
                                                placeholder="Search…"
                                                value={keyword || ''}
                                                onChange={(event) => {
                                                    this.setState({ keyword: event.target.value });
                                                }}
                                            />
                                            <Button type="submit" variant="primary">
                                                Search
                                            </Button>
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup controlId="tooling-status-filter">
                                        <Form.Label>Tooling Status</Form.Label>
                                        <Form.Select
                                            value={this.state.statusFilter}
                                            onChange={(event) => {
                                                this.setState(
                                                    {
                                                        statusFilter: event.target.value,
                                                        currentPage: 1,
                                                        offset: 0,
                                                    },
                                                    () => this.buildHtmlTable(1, this.state.rowsPerPage)
                                                );
                                            }}
                                        >
                                            <option value="all">All statuses</option>
                                            {Object.entries(TOOLING_CONDITION_LABELS).map(
                                                ([value, label]) => (
                                                    <option key={value} value={value}>
                                                        {label}
                                                    </option>
                                                )
                                            )}
                                        </Form.Select>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                        <DataTable
                            columns={this.columns}
                            data={products || []}
                            customStyles={TOOLING_TABLE_STYLES}
                            progressPending={this.state.loading}
                            progressComponent={
                                <DatacoLoadingIndicator
                                    loading={this.state.loading}
                                    size="compact"
                                    label="Loading tooling master data"
                                />
                            }
                            pagination
                            paginationServer
                            paginationComponent={ToolingMasterDataPagination}
                            paginationTotalRows={this.state.totalRows}
                            paginationPerPage={this.state.rowsPerPage}
                            paginationDefaultPage={this.state.currentPage}
                            onChangePage={this.handlePageChange}
                            onChangeRowsPerPage={this.handleRowsPerPageChange}
                            striped
                            highlightOnHover
                        />
                    </Card.Body>
                </Card>
                <a id="dlink" style={{ display: 'none' }}></a>
                <div id="tooling-master-data-export-table" style={{ display: 'none' }}>
                    <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ padding: '6px' }}>No</th>
                                <th style={{ padding: '6px' }}>Part No</th>
                                <th style={{ padding: '6px' }}>Tooling No</th>
                                <th style={{ padding: '6px' }}>Tooling System</th>
                                <th style={{ padding: '6px' }}>Tooling Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(products || []).map((item, index) => (
                                <tr key={item.id || index}>
                                    <td style={{ padding: '4px' }}>{item.no || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.partNo || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.toolingNo || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.toolingSystem || ''}</td>
                                    <td style={{ padding: '4px' }}>{this.getToolingConditionLabel(item.toolingCondition)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {modalShow && (
                    <Modal size="lg" show={modalShow} onHide={handleClose}
                        aria-labelledby="example-modal-sizes-title-lg" dialogClassName="modal-90w"
                        key={`modal-${this.state.id || 'new'}`}>
                        <Modal.Header closeButton>
                            <Modal.Title>{canManage ? newMode ? 'New' : 'Edit' : 'View'} Tooling Master Data</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <fieldset disabled={!canManage}>
                            <div>
                                <Form>
                                    <FormGroup className="row" as={Row} controlId="formInlineToolingNo" style={{ marginBottom: '15px' }}>
                                        <Col sm={3}><Form.Label>Part No</Form.Label></Col>
                                        <Col sm={3}>
                                            <MasterPartNoInput
                                                value={partNo}
                                                onChange={value => this.setState({ partNo: value })}
                                                enabled={true}
                                                onValidationChange={this.handlePartNoValidationChange}
                                            />
                                        </Col>
                                        <Col sm={3}><Form.Label>Tooling No</Form.Label></Col>
                                        <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ toolingNo: ev.target.value }); }} value={toolingNo} /></Col>
                                    </FormGroup>
                                    <FormGroup className="row" as={Row} controlId="formInlineToolingSystem" style={{ marginBottom: '15px' }}>
                                        <Col sm={3}><Form.Label>Tooling System</Form.Label></Col>
                                        <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ toolingSystem: ev.target.value }); }} value={toolingSystem} /></Col>
                                        <Col sm={3}><Form.Label>Tooling Status</Form.Label></Col>
                                        <Col sm={3}>
                                            <FormControl as="select"
                                                value={String(toolingCondition)}
                                                onChange={ev => { this.setState({ toolingCondition: Number(ev.target.value) }); }}>
                                                <option value="0">OK</option>
                                                <option value="1">NG</option>
                                                <option value="2">Under repair</option>
                                                <option value="3">End of Life</option>
                                            </FormControl>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="row" as={Row} controlId="formInlineToolingLifeAlert" style={{ marginBottom: '15px' }}>
                                        <Col sm={3}><Form.Label>Tooling Life Alert (Pcs)</Form.Label></Col>
                                        <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ toolingLifeAlert: Number(ev.target.value) || 0 }); }} value={toolingLifeAlert} /></Col>
                                        <Col sm={3}><Form.Label>Tooling Life (Pcs)</Form.Label></Col>
                                        <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ toolingLife: Number(ev.target.value) || 0 }); }} value={toolingLife} /></Col>
                                    </FormGroup>
                                    <FormGroup className="row" as={Row} controlId="formInlineNoCavity" style={{ marginBottom: '15px' }}>
                                        <Col sm={3}><Form.Label>No. Cavity</Form.Label></Col>
                                        <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ noCavity: Number(ev.target.value) || 0 }); }} value={noCavity} /></Col>
                                        <Col sm={3}><Form.Label>Machine Tonnage</Form.Label></Col>
                                        <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ machineTonnage: Number(ev.target.value) || 0 }); }} value={machineTonnage} /></Col>
                                    </FormGroup>
                                    <FormGroup className="row" as={Row} controlId="formInlineBaseMaterial" style={{ marginBottom: '15px' }}>
                                        <Col sm={3}><Form.Label>Base Material</Form.Label></Col>
                                        <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ baseMaterial: ev.target.value }); }} value={baseMaterial} /></Col>
                                        <Col sm={3}><Form.Label>Insert Steel</Form.Label></Col>
                                        <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ insertSteel: ev.target.value }); }} value={insertSteel} /></Col>
                                    </FormGroup>
                                    <FormGroup className="row" as={Row} controlId="formInlineCoreSteel" style={{ marginBottom: '15px' }}>
                                        <Col sm={3}><Form.Label>Core Steel</Form.Label></Col>
                                        <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ coreSteel: ev.target.value }); }} value={coreSteel} /></Col>
                                        <Col sm={3}><Form.Label>Ejection System</Form.Label></Col>
                                        <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ ejectionSystem: ev.target.value }); }} value={ejectionSystem} /></Col>
                                    </FormGroup>
                                    <FormGroup className="row" as={Row} controlId="formInlineRawMaterialGrade" style={{ marginBottom: '15px' }}>
                                        <Col sm={3}><Form.Label>Raw Material Grade</Form.Label></Col>
                                        <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ rawMaterialGrade: ev.target.value }); }} value={rawMaterialGrade} /></Col>
                                        <Col sm={3}><Form.Label>Surface Requirement</Form.Label></Col>
                                        <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ surfaceRequirement: ev.target.value }); }} value={surfaceRequirement} /></Col>
                                    </FormGroup>
                                    <FormGroup className="row" as={Row} controlId="formInlinePartWeightNet" style={{ marginBottom: '15px' }}>
                                        <Col sm={3}><Form.Label>Part Weight (Net) grams</Form.Label></Col>
                                        <Col sm={3}><FormControl type="number" step="1" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ partWeightNet: Number(ev.target.value) || 0 }); }} value={partWeightNet} /></Col>
                                        <Col sm={3}><Form.Label>Shot Weight (Gross) grams</Form.Label></Col>
                                        <Col sm={3}><FormControl type="number" step="1" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ shotWeightGross: Number(ev.target.value) || 0 }); }} value={shotWeightGross} /></Col>
                                    </FormGroup>
                                    <FormGroup className="row" as={Row} controlId="formInlineRequiredMachineTonnage" style={{ marginBottom: '15px' }}>
                                        <Col sm={3}><Form.Label>Required Machine Tonnage (Tons)</Form.Label></Col>
                                        <Col sm={3}><FormControl type="number" step="1" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ requiredMachineTonnage: Number(ev.target.value) || 0 }); }} value={requiredMachineTonnage} /></Col>
                                    </FormGroup>
                                </Form>
                            </div>
                            </fieldset>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Cancel
                            </Button>
                            {canManage && newMode && (<Button variant="primary" onClick={handleCreate} disabled={!isPartNoCreateEnabled(this.state.partNoValidationStatus)}>
                                Create
                            </Button>)}
                            {canManage && !newMode && (<Button variant="primary" onClick={handleSave} disabled={!isPartNoCreateEnabled(this.state.partNoValidationStatus)}>
                                Save Changes
                            </Button>)}
                        </Modal.Footer>
                    </Modal>
                )}
            </div>
        );
    }
}

export { ToolingMasterData };
